import { ParcelRole } from './phaseParcelsApi';

/**
 * What belongs to the plot, and therefore what a click does.
 *
 * Its own module rather than a helper inside the map, for two reasons that turn out to be one. It
 * is a rule about the plot, not about drawing — the list beside the map asks the same question the
 * map does. And a rule worth testing must be reachable without loading a map: importing the map
 * component pulls in mapbox-gl, which needs a browser and dies in a test runner.
 *
 * `core`, `accepted` and `manual` are the plot: determined, assessed and settled by hand
 * respectively, all three certain and all three counted into the area. `open` is drawn but is not
 * part of it — the estimator has not decided — so clicking it *adds* it rather than removing it,
 * which is also what a reader expects of something shown as unsettled.
 */
const CERTAIN: ParcelRole[] = ['core', 'manual', 'accepted'];

export const isOnPlot = (role: ParcelRole | undefined): boolean =>
    role !== undefined && CERTAIN.includes(role);
